import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/user-groups/UserGroupsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { UserGroupEditForm } from "./UserGroupEditForm";

export function UserGroupEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, userGroup } = useSelector(
    (state) => ({
      actionsLoading: state.userGroups.actionsLoading,
      isSuccess: state.userGroups.isSuccess,
      type: state.userGroups.type,
      userGroup: state.userGroups.userGroup,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getUserGroup(id));
    return () => dispatch(actions.cleanUserGroupsState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Kullanıcı Grubu";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  const saveUserGroup = (values) => {
    dispatch(actions.saveUserGroup(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/kullanici-gruplari`), 2500);
  };

  const btnRef = useRef();  
  const saveUserGroupClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <UserGroupEditForm 
            userGroup={userGroup}
            btnRef={btnRef} 
            saveUserGroup={saveUserGroup}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveUserGroupClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}